import type { Portfolios } from '@/hooks/portfolio/usePortfolio';

export const getPortfoliosCountByLimits = (portfolios: Portfolios) => {
  const fullyLimitedPortfolios = portfolios.filter(
    (portfolio) => portfolio.isAnalysisRestricted
  ).length;
  const nonFullyLimitedPortfolios = portfolios.filter(
    (portfolio) => !portfolio.isAnalysisRestricted
  );
  const partiallyLimitedPortfolios = nonFullyLimitedPortfolios.filter(
    (portfolio) =>
      portfolio.holdings.some((holding) => holding.isAnalysisRestricted)
  ).length;

  return {
    fullyLimitedPortfolios,
    partiallyLimitedPortfolios,
  };
};
